<div class="bg-col-w p-t search-in-off-canvas-container">
    @if (!!shouldShow) {
    <div class="wrap-x wrap-l p-b-8 p-b-26-s center search-in-off-canvas-wrap">
        <div class="w-12 left p-l-2 p-r-2 p-r-0-m p-r-0-s p-l-0-m p-l-0-s">
            @if(useKlevu && term) {
            <search-banner [position]="'top'"
                           class="m-t-2-s wrap-s wrap-m"
                           [context]="'preview'"
                           [term]="term"></search-banner>
            }

            <div class="m-t">
                <!-- categories -->
                @if (hasNonProductResults) {
                <div class="wrap-s wrap-m p-b-10-s p-b-10-m p-b-4-x p-b-4-l  m w-4 w-12-m w-12-s">
                    <ng-container *ifSize="'!SM'">
                        @if (popularSearches?.length) {
                        <h3 class="p-b-1 p-b-0-s col-12 h3">{{ popularSearchesLabel | translate }}</h3>
                        @for (term of popularSearches; track $index) {
                        <a class="block m-t m-t-3-s p2 _terms"
                           [routerLink]="term.redirect || ['search', term.barePhrase]"
                           [innerHtml]="term.phrase"></a>
                        }
                        }
                        @if (suggestedPages?.length) {
                        <h3 class="p-b-1 m-t-8 p-b-0-s col-12 h3">{{ suggestedPagesLabel | translate }}</h3>
                        @for (model of suggestedPages; track $index) {
                        <a class="block m-t m-t-3-s p2 _terms"
                           [routerLink]="model.link"
                           [innerHtml]="model.name"></a>
                        }
                        }
                        @if (suggestedCategories?.length) {
                        <h3 class="p-b-1 m-t-8 p-b-0-s col-12 h3">{{ suggestedCategoriesLabel | translate }}</h3>
                        @for (model of suggestedCategories; track $index) {
                        <a class="block m-t m-t-3-s p2 _terms"
                           [routerLink]="model.link"
                           [innerHtml]="model.name"></a>
                        }
                        }
                    </ng-container>
                    <ng-container *ifSize="'SM'">
                        <div class="flex flex-middle p-b-1">
                            @if (popularSearches?.length) {
                            <h3 class="p-b-1 b-b b-col-1 col-1 h4"
                                [toggle]="['search', 0]"
                                [toggleClass]="'!col-12 !b-col-t col-1 b-col-1'"
                                [toggleClassBy]="['search', 0]"
                                [toggleClassActive]="true">{{ popularSearchesLabel | translate }}</h3>
                            @if (suggestedPages?.length) {
                            <span class="_divider"></span>
                            }
                            }
                            @if (suggestedPages?.length) {
                            <h3 class="p-b-1 b-b h4"
                                [toggle]="['search', 1]"
                                [toggleClass]="'!col-12 !b-col-t col-1 b-col-1'"
                                [toggleClassBy]="['search', 1]">{{ suggestedPagesLabel |
                                translate }}</h3>
                            }
                        </div>
                        @if (popularSearches?.length) {
                        <div [toggleClass]="'!ng-hide'"
                             [toggleClassBy]="['search', 0]">
                            @for (term of popularSearches; track $index) {
                            <a class="block m-t-3 p2 _terms"
                               [routerLink]="term.redirect || ['search', term.barePhrase]"
                               [innerHtml]="term.phrase"></a>
                            }
                        </div>
                        }
                        @if (suggestedPages?.length) {
                        <div class="ng-hide"
                             [toggleClass]="'!ng-hide'"
                             [toggleClassBy]="['search', 1]">
                            @for (model of suggestedPages; track $index) {
                            @if(model.image) {
                            <a class="flex flex-middle m-t-3 p2 _terms"
                               [routerLink]="model.link">
                                <div class="m-r-3 ratio-1-1 _terms-image">
                                    <img class="rf"
                                         [image]="model.image">
                                </div>
                                <div class="_terms"
                                     [innerHtml]="model.name">
                                </div>
                            </a>
                            } @else {
                            <a class="block m-t-3 p2 _terms"
                               [routerLink]="model.link"
                               [innerHtml]="model.name"></a>
                            }

                            }
                        </div>
                        }
                    </ng-container>
                </div>
                }
                <!-- products -->
                @if (products) {
                <div class="wrap-s wrap-m w-12-m w-12-s p-l-2-x p-l-2-l"
                     [ngClass]="hasNonProductResults ? 'w-8' : 'w-12'"
                     cy-quickSearchProductListing>
                    <div class="w-12 flex flex-justify-between flex-middle">
                        <h3 [sizeClass]="'!SM: h3 col-12, SM: h4 col-1'">{{ 'Products' | translate }}</h3>
                        <a class="underline col-12 italic p2"
                           [routerLink]="'/search/' + term">{{ 'View all' | translate }}</a>
                    </div>
                    <div class="search-in-off-canvas-container-grid m-t"
                         [grid]="[2, 3, 4, 4][client.sizeId]"
                         [gridColumnGap]="['15px', '15px', '40px', '40px'][client.sizeId]">
                        @for (model of products; track $index; let i = $index) {
                        <product [searchTerm]="term"
                                 [klevuTrackClick]="klevuTrackData(model)"
                                 [gridColumn]="1"
                                 [gridRowSpan]="1"
                                 [gtmImpressionTrack]="{productId: model.id, position: i+1, list: 'Search results',  numberOfResults: products.length}"
                                 [gtmTrackProductClick]="{productId: model.id, position: i+1, list: 'Search results'}"
                                 [modelId]="model.id"
                                 [acItem]="productAsAdvancedCommerceItem(model)"
                                 [acClickCode]="clickCode"
                                 [canShowTieredPrice]="true" />
                        }
                    </div>
                    <ng-container *ifSize="'SM'">
                        @if (suggestedCategories?.length) {
                        <h3 class="p-b-1 b-b b-col-1 col-1 h4 inline-block m-t-6">{{ suggestedCategoriesLabel |
                            translate }}</h3>
                        @for (model of suggestedCategories; track $index) {
                        <a class="block m-t-3 p2"
                           [routerLink]="model.link"
                           [innerHtml]="model.name"></a>
                        }
                        }
                    </ng-container>
                </div>
                }
            </div>
            @if(useKlevu && term) {
            <search-banner [position]="'bottom'"
                           [context]="'preview'"
                           class="m-t wrap-s wrap-m"
                           [term]="term" />
            }
        </div>
    </div>
    } @else {
    <div class="block w-12 p-t p-b-10">
        <ng-container *ngComponentOutlet="
                                    noResultsOutlet.component;
                                    inputs: $any(noResultsOutlet.inputs);
                                    " />
    </div>
    }
</div>